import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  IsBoolean,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2LarkArticleTableResponse {
  code: number;
  msg: string;
  data: AgentV2LarkArticleTable;
};

export interface AgentV2LarkArticleTable {
  has_more: boolean;
  page_token?: string;
  total: number;
  items: Array<LarkArticleTableItems>;
};

export interface LarkArticleTableItems {
  record_id: string;
  fields: LarkArticleTableItemFields;
};

export interface LarkArticleTableItemFields {
  json: string;
  modelName: string;
  preview_image: Array<PreviewImage>;
  template_id: string;
};

export interface PreviewImage {
  file_token: string;
  name: string;
  size: number;
  tmp_url: string;
  type: string;
  url: string;
};

// 请求接口
export interface AgentV2LarkArticleTableRequest {
  pageToken: string,
  pageSize: string,
  templateId?: string,
  agentId?: string,
}

export class PreviewImageData {
  @IsString("File token must be a string")
  fileToken: string;

  @IsString("Name must be a string")
  name: string;

  @IsNumber("Size must be a number")
  size: number;

  @IsString("Tmp URL must be a string")
  tmpUrl: string;

  @Required("Actual image URL cannot be empty")
  @IsString("Actual image URL must be a string")
  actualImageUrl: string;

  @IsString("Type must be a string")
  type: string;

  @IsString("URL must be a string")
  url: string;
}

// * 重点取值对象
export class LarkArticleTableItemFieldsData {
  @Required("Model name cannot be empty")
  @IsString("Model name must be a string")
  modelName: string;

  @Required("Template ID cannot be empty")
  @IsString("Template ID must be a string")
  templateId: string;

  @Required("Preview image cannot be empty")
  @ValidateNested(PreviewImageData)
  previewImage: PreviewImageData[];
}

export class LarkArticleTableItemsData {
  // @Required("Record ID cannot be empty")
  @IsString("Record ID must be a string")
  recordId: string;

  @Required("Fields cannot be empty")
  @ValidateNested(LarkArticleTableItemFieldsData)
  fields: LarkArticleTableItemFieldsData;

  @IsNumber("Template resource must be a number")
  templateResource: number;
}

export class AgentV2LarkArticleTableData {
  // @Required("Has more cannot be empty")
  @IsBoolean("Has more must be a boolean")
  hasMore: boolean;

  // @Required("Page token cannot be empty")
  @IsString("Page token must be a string")
  pageToken: string;

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Items cannot be empty")
  @IsArray("Items must be an array")
  items: Array<LarkArticleTableItemsData>;
}

class AgentV2LarkArticleTableResponseData {
  // @Required("Code cannot be empty")
  @IsNumber("Code must be a number")
  code: number;

  // @Required("Msg cannot be empty")
  @IsString("Msg must be a string")
  msg: string;

  @Required("Data cannot be empty")
  // @ValidateNested(AgentV2LarkArticleTableData)
  data: AgentV2LarkArticleTableData;
}

const transformAndValidateAgent = (
  response: AgentV2LarkArticleTableResponse
): AgentV2LarkArticleTableResponseData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2LarkArticleTableResponseData);
  } catch (error) {
    console.error("Agent V2 Lark Article Table data validation failed:", error.message);
    throw error;
  }
};

/** 飞书文章模版 */
export const agentV2LarkArticleTable = async ({
  pageToken,
  pageSize,
  templateId,
  agentId,
}: AgentV2LarkArticleTableRequest): Promise<AgentV2LarkArticleTableResponseData> => {
  const response = await api.post<AgentV2LarkArticleTableResponse>('/agent-v2/feishu-table-data', {
    page_token: pageToken,
    page_size: pageSize,
    template_id: templateId,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
